/**
 * Initialize all owl-carousel instances on the page.
 * Shared between B2B (script.js) and Catalog (script_catalog.js).
 * Call inside a $(document).ready() block.
 */
export function initOwlCarousels() {
    // Gallery slideable (CMS gallery sitepart)
    if ($('.gallery_slideable .row').length > 0) {
        $('.gallery_slideable .row').addClass('owl-carousel');
        $('.gallery_slideable .owl-carousel').owlCarousel({
            autoplay: false,
            loop: true,
            margin: 20,
            autoHeight: false,
            autoWidth: true,
            nav: true,
            dots: false,
            navText: ['<i class="icon icon-29-long-arrow-left-solid"></i>', '<i class="icon icon-28-long-arrow-right-solid"></i>'],
        });
    }

    // Item card images (product detail page)
    if ($('#itemcard_left .itemcard_images > .owl-carousel').length > 0) {
        $('#itemcard_left .itemcard_images > .owl-carousel').owlCarousel({
            autoplay: false,
            loop: false,
            items: 1,
            autoHeight: false,
            autoWidth: false,
            nav: true,
            dots: false,
            navText: ['<i class="icon icon-arrow-left"></i>', '<i class="icon icon-arrow-right"></i>'],
        });
    }

    // Shop item preview carousel (item list type 21)
    if ($('.shop_item_preview .owl-carousel').length > 0) {
        $('.shop_item_preview .owl-carousel').owlCarousel({
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 6000,
            loop: false,
            items: 5,
            checkVisible: false,
            autoHeight: false,
            autoWidth: false,
            nav: true,
            dots: false,
            navText: ['<i class="icon icon-arrow-left"></i>', '<i class="icon icon-arrow-right"></i>'],
            responsive: {
                0: {
                    items: 1,
                    nav: false,
                },
                480: {
                    items: 2,
                    nav: false,
                },
                768: {
                    nav: false,
                    items: 3
                },
                1024: {
                    items: 4
                },
                1249: {
                    items: 4
                },
                1600: {
                    items: 5
                }
            }
        });
    }

    // Variant images on item card (product detail page)
    if ($('.itemcardVariantImages > .owl-carousel').length > 0) {
        $('.itemcardVariantImages > .owl-carousel').owlCarousel({
            loop: false,
            autoplay: false,
            autoHeight: false,
            autoWidth: true,
            navText: ['<i class="icon icon-arrow-left"></i>', '<i class="icon icon-arrow-right"></i>'],
            nav: true
        });
    }

    // "Mein Sortiment" design card: one slide per preview view (#239).
    // Mouse: arrows + dots only, so a click on the image stays a click (it
    // navigates to the configurator via individualizedItemCard.js) and the
    // jQuery UI sortable grid keeps its drag handle. Touch: swipe is on; the
    // sortable only starts from .js-drag-item, and Owl swallows the click
    // that would follow a swipe. touch-action: pan-y comes from the LESS,
    // Owl only sets it for mouseDrag.
    if ($('.design-card-carousel').length > 0) {
        $('.design-card-carousel').owlCarousel({
            items: 1,
            loop: false,
            autoplay: false,
            autoHeight: false,
            autoWidth: false,
            mouseDrag: false,
            touchDrag: true,
            nav: true,
            dots: true,
            navText: ['<i class="icon icon-arrow-left"></i>', '<i class="icon icon-arrow-right"></i>'],
        });
    }

    // Variant images in item list
    if ($('.variantImages.itemlist_variants.owl-carousel').length > 0) {
        $('.variantImages.itemlist_variants.owl-carousel').owlCarousel({
            loop: false,
            autoplay: false,
            autoHeight: false,
            autoWidth: true,
            items: 5,
            navText: ['<i class="icon icon-arrow-left"></i>', '<i class="icon icon-arrow-right"></i>'],
            nav: true
        });
    }
}
